import React from 'react';
import './Gallery.css';

const Gallery = () => {
  // Use all 9 emoji images with png extension
  const figures = Array.from({ length: 9 }, (_, index) => 
    `/images/emoji${index + 1}.png`
  );
  
  // Array of fake generation prompts for each image
  const imagePrompts = [
    "Create an emoji figure with rounded features and exaggerated expression, sealed in collectible packaging",
    "Generate a stylized action figure with bright yellow color scheme and raised eyebrows for surprise",
    "Design a wide-eyed emoji character with textured surface and highly detailed packaging",
    "Craft a smiling emoji figure with glossy finish and three accessories: sunglasses, phone, and hat",
    "Make a winking emoji action figure with metallic finish in futuristic blister packaging",
    "Create a laughing emoji character with bold outlines and exaggerated features in collector's packaging",
    "Generate a thoughtful-looking emoji figure with subtle gradient coloring and premium display case",
    "Design a cool emoji action figure wearing sunglasses with retro-inspired packaging design",
    "Craft a sleek emoji character with minimalist features and elegant display stand in modern packaging"
  ];

  return (
    <div className="gallery-page">
      <div className="container">
        <h1 className="section-title">Gallery</h1>
        
        <div className="gallery-grid">
          {figures.map((figure, index) => (
            <div key={index} className="gallery-item">
              <img src={figure} alt={`Action Figure ${index + 1}`} />
              <div className="prompt-text">
                <p>{imagePrompts[index]}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery; 